import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input, OnDestroy,
  OnInit,
  OnChanges,
  Optional,
  Output,
  Self,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  NgControl,
  Validators
} from '@angular/forms';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatFormFieldControl } from '@angular/material/form-field';
import { FocusMonitor } from '@angular/cdk/a11y';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { MAT_SELECT_CONFIG, MatSelect } from '@angular/material/select';


import { RequestAttribute, RequestParams } from '../../../../../utils/models/http.interface';
import { HttpService } from '../../../../service/http/http.service';
import { environment } from '../../../../../environments/environment';
import { IconsSelectInfiniteScroll } from '../../../../../utils/models/common.interface';
import { ConfigApiDynamicTable } from '../../../../../utils/models/table.interface';
import { TitleSelect } from '../../../../../utils/models/input.interface';
import moment from 'moment';

export function validateCounterRange(c: FormControl) {
  const err = {
    rangeError: {
      given: c.value
    }
  };
  return (c.value === undefined || c.value === null) ? err : null;
}

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'select-infinite-scroll-search',
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: SelectInfiniteScrollSearchComponent
    },
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'custom-overlayer-select-infinite-scroll' }
    }
  ],
  templateUrl: './select-infinite-scroll-search.component.html',
  styleUrls: ['./select-infinite-scroll-search.component.scss']
})
export class SelectInfiniteScrollSearchComponent implements OnInit, OnChanges,
MatFormFieldControl<any>, ControlValueAccessor, AfterViewInit, OnDestroy, Validators {
  private readonly apiUrl: string = environment.apiUrl;

  stateChanges = new Subject<void>();

  @Input() configApi: ConfigApiDynamicTable;

  @Input()
  set options(arr: any[]) {
    if (arr) {
      this._options = [...arr];
      this._options = this._options.filter(o => !!o);
      this._oprtionOriginal = [...arr];
      this._oprtionOriginal = this._oprtionOriginal.filter(o => !!o);
    }
  }

  @Input()
  set value(obj: any | null) {
    this._value = obj;
  }
  get value(): any | null {
    if (this._value) {
      return this._value;
    } else {
      return 'teste';
    }
  }

  @Input()
  get required(): boolean {
    return this._required;
  }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  get errorState() {
    const controlDirectiveAux: any = this.controlDirective;
    let parent = controlDirectiveAux?._parent;
    while (parent?._parent) {
      parent = parent._parent;
    }
    if (parent?.submitted) {
      return !!this.controlDirective?.invalid && !this.controlDirective.disabled;
    } else {
      return !!this.controlDirective?.invalid && this.touched;
    }
  }
  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(plh) {
    this._placeholder = plh;
    this.stateChanges.next();
  }

  get empty() {
    return !this._value;
  }

  @HostBinding('class.floating')
  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this._disabled ? this.parts?.disable() : this.parts?.enable();
    this.stateChanges.next();
  }

  constructor(
    private readonly httpService: HttpService,
    private readonly fm: FocusMonitor,
    private readonly elRef: ElementRef<HTMLElement>,
    @Optional() @Self() public controlDirective: NgControl,
    private readonly cdRef: ChangeDetectorRef) {
      const sleepTime = 300;
      this.sleep(sleepTime)
      .then(() => {
        if (this.initialGetOptions && !!this.endpoint && this.configApi) {
          if (this.returnVariable) {
            this.httpService.genericGetSelectInfinite<any>(this.configApi, this.endpoint, null, this.requestParams, this.attributes)
              .subscribe((object: any[] | any) => {
                this._options = this._options?.length === 0 ? null : this._options
                if (this.hasCount) {
                  this._options ? this._options.unshift(object?.rows) : this._options = object?.rows;
                } else {
                  this._options ? this._options.unshift(object) : this._options = object;
                }
                const index = this._options.findIndex((option: any, i: number, options: any[]) => {
                  return (option[this.returnVariable] === options[0][this.returnVariable] && i !== 0);
                });
                if (index !== -1) {
                  this._options.splice(index, 1);
                }
                this._oprtionOriginal = this._options
              });
          } else {
            this.httpService.genericGetSelectInfinite<any>(this.configApi, this.endpoint, null, this.requestParams, this.attributes)
              .subscribe((object: any[] | any) => {
                this._options = this._options?.length === 0 ? null : this._options;
                if (!!this._options) {
                  this.options = [...(this.options || []), ...(this.hasCount ? object?.rows : object)]
                } else {
                  this._options = (this.hasCount ? object?.rows : object)
                }
                const index = this._options.findIndex((option: any, i: number, options: any[]) => {
                  if(option.id){
                    return (option.id === options[0].id && i !== 0);
                  }
                });
                if (index !== -1) {
                  this._options.splice(index, 1);
                }
              });
              this._oprtionOriginal = this._options
          }
        }
      });
    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
    if (this.controlDirective) {
      this.controlDirective.valueAccessor = this;
    }
  }

  static nextId = 0;

  _options;
  _oprtionOriginal;

  @Input() internalFilter: false;
  @Input() disabledOptions: any;

  @Input() endpoint: string;
  @Input() multiple: boolean;
  @Input() enableInfScroll = true;
  @Input() labelShow: string;
  @Input() labelShowPref: string;
  @Input() labelShowSuf: string;
  @Input() labelShowSearch: string;
  @Input() labelShowSufDate: string;
  @Input() parts;
  @Input() hasCount: boolean;
  @Input() returnVariable: string = undefined;
  @Input() alphabeticalOrder = false;
  @Input() alphabeticalShort: any
  @Input() selectAll: string;
  @Input() triggerSelectAll: string;
  @Input() selectLimit = null;
  @Input() removeButtons = false;
  @Input() heightBoxSelect = '16rem'

  @Input() inputSearch: string = undefined;
  @Input() filterSearch = true;
  @Input() hasEmptyOption: false;
  @Input() isTableFilter = false;
  @Input() filterName: string;
  @Input() filterAllOptionsName = 'All {total} options';
  @Input() max: number = 1;
  @Input() initialGetOptions = false;
  @Input() iconsButtons: IconsSelectInfiniteScroll;
  @Input() autoComplete = false;
  @Input() textEmptyOptions = '';
  @Input() containsFormfield = false;
  @Input() titleSelect: TitleSelect;
  @Input() hasBooleanValue = false;
  @Input() maxCharacters: number;
  @Input() placeholderSearch = 'Pesquisar...';

  @Output() selectionObjectChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectionTouched: EventEmitter<any> = new EventEmitter<any>();
  @Output() optionEmmiter: EventEmitter<any> = new EventEmitter<any>();
  @Output() inputSearchEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() clearFilter: EventEmitter<any> = new EventEmitter<any>();
  @Output() filterEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeSelect: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('multiSelect') multiSelect: MatSelect;

  complete = false;

  touched = false;

  @Input() attributes: RequestAttribute[] = [];
  _value: any = [];
  _required = false;
  _placeholder: string;
  valueTrigger = [];
  optionTrigger = [];


  ngControl: NgControl = null;
  focused = false;

  @HostBinding() id = `example-tel-input-${SelectInfiniteScrollSearchComponent.nextId++}`;
  @HostBinding('attr.aria-describedby') describedBy = '';
  private _disabled = false;
  @Input() disabledAux = false;
  // tslint:disable-next-line: variable-name
  private readonly _onDestroy = new Subject<void>();

  public formAux: FormControl = new FormControl();

  loading = false;
  requestParams: RequestParams = {
    sort: '',
    order: '',
    page: 1,
    limit: 30,
  };

  initialData: any = [];
  restore = true;

  AttLabs = false;
  atualizarLabelShowAtt = false;
  atualizarLabelShowPrefAtt = false;
  atualizarLabelShowSufAtt = false;

  returnAllOptionText(): string {
    return this.filterAllOptionsName.replace('{total}', `${this._options.length}`);
  }

  openedSelect() {
    const fatherElement: any = this.elRef.nativeElement.parentNode.parentNode;
    fatherElement.classList.toggle('focus-open-select');
    const elementPanel: any = document.querySelector('.panel-select-infinite.mat-select-panel');
    if (elementPanel) {
      const rect = elementPanel.getBoundingClientRect();
      const isOverflowing = rect.bottom + 100 > window.innerHeight;
      if (isOverflowing) {
        const currentTop = window.getComputedStyle(elementPanel).top;
        const availableHeight = Math.floor(window.innerHeight - rect.top) - 4;

        if(availableHeight < 240){
          elementPanel.style.top =  `calc(${currentTop} - ${rect.height + 50}px)`;
        } else {
          elementPanel.style.maxHeight = `${availableHeight - 10}px`;
        }
      } else {
        elementPanel.style.maxHeight = this.heightBoxSelect;
      }
    }
  }

  filtrar() {
    this.filterEvent.emit(this._value);
    this.restore = false;
    this.multiSelect.toggle();
  }

  getLimitMaxCharacters(value: any): boolean {
    if(!!value){
      const splitVal = value?.toString().split(' ');
      if (splitVal.length > 0 && this.maxCharacters) {
        let containMaxCharacters = false;
        splitVal.forEach(res => {
          if (res.split('').length > this.maxCharacters) {
            containMaxCharacters = true;
            return null;
          }
        });
        return containMaxCharacters;
      }
    }else{
      return false;
    }

  }

  limpar() {
    this.clearOptions();
    this.clearFilter.emit();
    this.multiSelect?.toggle();
  }

  clearOptions() {
    this.writeValue(this.multiple ? [] : '');
    this.stateChanges.next();
    this.restore = false;
    this.complete = false;
    this.cdRef.detectChanges();
    this.propagateChange(this._value);
    this.selectionChange.emit(this._value);
    this.selectionObjectChange.emit(null);
  }

  handleAplly() {
    this.multiSelect.toggle();
    this.closeSelect.emit(this._value);
  }

  assignValueTriggerStarts(fields) {
    if (fields?.length > 0 && this._options?.length > 0 && this.optionTrigger?.length === 0) {
      fields?.forEach(field => {
        const findOpt = this._options?.find(res => res[this.returnVariable] || (this.hasBooleanValue && res[this.returnVariable] === false) ? res[this.returnVariable] === field : res === field);

        if (findOpt) {
          this.optionTrigger.push(findOpt);
        }
      });
    }
  }

  getValueTrigger(fields) {
    const arrayFields = [];
    this.assignValueTriggerStarts(fields);
    if(fields) {
      fields?.forEach(field => {
        if (field === 'all') {
          arrayFields.push(this.triggerSelectAll);
        } else {
          const findOpt = this.optionTrigger?.find(res => res[this.returnVariable] || (this.hasBooleanValue && res[this.returnVariable] === false) ? res[this.returnVariable] === field : res === field);
          arrayFields.push(findOpt && findOpt[this.labelShow] ? findOpt[this.labelShow] : findOpt && !findOpt[this.labelShow] ? findOpt : '.');
        }
      });
      return arrayFields.length > 0 ? arrayFields.splice(0, this.max): [];
    }
  }

  getCountTrigger(fields) {
    return fields?.length ? (fields.length - this.max) : 0;
  }

  returnWidthTrigger(fields): string {
    const addMax = fields?.length > this.max ? 26 : 0;
    let minifyItems = 1, marginItems = 1;
    if (fields?.length) {
      minifyItems = fields.length > this.max ? this.max : fields.length;
      marginItems = fields.length > 1 ? 2.5 : 1;
    }
    const value_text = this.elRef.nativeElement.querySelector('.mat-select-value-text');
    if (value_text) {
      const widthValueText = value_text.clientWidth;
      let valueMax = 0;
      fields?.forEach(trigger => {
        const findOpt = this.optionTrigger?.find(res => res[this.returnVariable] || (this.hasBooleanValue && res[this.returnVariable] === false) ? res[this.returnVariable] === trigger : res === trigger);
        const valuetrigger = (findOpt && findOpt[this.labelShow] ? findOpt[this.labelShow] : findOpt && !findOpt[this.labelShow] ? findOpt : '.');
        valueMax += (valuetrigger?.split('').length * 11) + 13
      });
      return valueMax > widthValueText ? `calc(${100 / minifyItems}% - ${(addMax / minifyItems) + (minifyItems * marginItems)}px)` : '100%';
    } else {
      return '100%';
    }
  }

  validate(c: AbstractControl): { [key: string]: any } {
    // Here we call our static validator function
    return this.required ? Validators.required(c) : null;
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  clearSelection() {
    this._value = null;
    this._options = [];
    this.valueTrigger = [];
    this.optionTrigger = [];
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() !== 'div') {
      this.elRef.nativeElement.querySelector('div').focus();
    }
  }

  public setDisabledState(isDisabled: boolean): void {
    this._disabled = isDisabled;
    this.disabledAux = isDisabled;
  }

  writeValue(value: any) {
    this._value = value;
    this.addValueTrigger(this._value || []);
    this.cdRef.detectChanges();
  }

  addValueTrigger(value) {
    if (this.multiple) {
      value?.forEach(field => {
        const findOpt = this._options?.find(res => res[this.returnVariable] || (this.hasBooleanValue && res[this.returnVariable] === false) ? res[this.returnVariable] === field : res === field);
        if (findOpt) {
          this.optionTrigger.push(findOpt)
        }
      });
    }
  }

  propagateChange = (_: any) => { };

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() { }

  ngOnDestroy() {
    this.stateChanges.complete();
  }

  ngAfterViewInit(): void {
    this.controlDirective?.valueChanges?.subscribe(() => {
      this.setTouched();
    });

    if (this.isTableFilter) {
      this.multiSelect.openedChange.subscribe((value) => {
        if (value) {
          this.initialData = this._value;
        }
        if (!value && this.restore) {
          this._value = this.initialData;
          this.propagateChange(this._value);
        }
        this.restore = true;
      });
    }
  }

  createObjReturnAllCurrentObj(): void {
    if (this.multiple) {
      if (this._value?.indexOf('all') !== -1) {
        this.selectionObjectChange.emit(this._options);
      } else {
        const allObjectValue = [];
        this._value.forEach(field => {
          const findOpt = this._options?.find(res => res[this.returnVariable] ? res[this.returnVariable] === field : res === field);
          if (findOpt) {
            allObjectValue.push(findOpt);
          }
        });
        this.selectionObjectChange.emit(allObjectValue);
      }
    } else {
      const findOpt = this._options?.find(res => res[this.returnVariable] ? res[this.returnVariable] === this._value : res === this._value);
      if (findOpt) {
        this.selectionObjectChange.emit(findOpt);
      }
    }
  }

  select(e) {
    this.addValueTrigger(this._value || []);
    this.propagateChange(this._value);
    this.selectionChange.emit(this._value);
    this.createObjReturnAllCurrentObj();
  }

  clickOptFilter() {
    if (this.isTableFilter) {
      if (this._value.indexOf('allOpt') !== -1) {
        if (this._options.length + 1 !== this._value.length) {
          this.writeValue(this.value.filter(res => res !== 'allOpt'));
        }
      } else {
        if (this._options.length === this._value.length) {
          this.writeValue([...this._value, 'allOpt']);
        }
      }
    }
  }

  clickAllOpt() {
    const val = (this._value.indexOf('allOpt') !== -1 ? [...this._options, 'allOpt'] : []);
    this.writeValue(val);
  }

  clickAllOptSearch() {
    const val = (this._value.indexOf('all') !== -1 ? ['all'] : []);
    this.writeValue(val);
  }

  setTouched() {
    this.touched = true;
    this.selectionTouched.emit();
    this.stateChanges.next();
  }

  infiniteScroll() {
    if (this.formAux.value) {
      this.loading = false;
    }
    if (!this.loading && this.enableInfScroll && !this.internalFilter) {
      this.loading = true;
      this.requestParams.order = this.alphabeticalOrder ? 'asc' : '';
      this.requestParams.sort = this.alphabeticalShort ? this.alphabeticalShort : this.alphabeticalOrder ? this.labelShow : '';
      this.requestParams.page++;
      this.complementsInfiniteScroll();
    }
  }

  complementsInfiniteScroll() {
    const attributesRequest = this.attributes.filter(a => a.value);
    if (!this.complete) {
      this.complementsInfiniteScroll1(attributesRequest);
    }
  }

  complementsInfiniteScroll1(attributesRequest) {
    this.httpService.genericGetSelectFiltroScroll<[]>(this.configApi, this.endpoint, this.requestParams, attributesRequest)
      .subscribe((obj: any[] | any) => {
        this.loading = false;
        if (this.hasCount) {
          const index = (obj.rows).findIndex((option: any, i: number) => {
            return (option.id === this._options[0].id);
          });
          if (index !== -1) {
            (obj.rows).splice(index, 1);
          }
          this._options = this._options.concat(obj.rows);
          if (obj.rows.length === 0) {
            this.complete = true;
          }
        } else {
          const index = obj?.findIndex((option: any, i: number) => {
            return (option.id === this._options[0].id);
          });
          if (index !== -1) {
            obj.splice(index, 1);
          }
          this._options = this._options.concat(obj);
          if (obj.length === 0) {
            this.complete = true;
          }
        }
        this.optionEmmiter.emit(this._options);
      });
  }

  returnIfOptionIsDisabled(option: any, value?) {
    if (this.selectAll) {
      if(this.selectLimit && value?.length >= this.selectLimit){
        return Array.isArray(value) && value.indexOf('all') !== -1 ?  true :  Array.isArray(value) && value?.indexOf(option) !== -1 ? false : true;
      } else {
        return Array.isArray(value) && value?.indexOf('all') !== -1 ? true : false;
      }
    } else if(this.selectLimit && Array.isArray(value) && value.length >= this.selectLimit){
      return value?.indexOf(option) !== -1 ? false : true;
    } else {
      return (this.disabledOptions && this.disabledOptions.indexOf(+option) !== -1 ? true : false);
    }
  }

  ngOnChanges(changes) {
    if (this.inputSearch !== undefined && this.inputSearch !== null) {
      this.formAux.setValue(this.inputSearch);
    }
    if (changes?.options && !changes.options.firstChange) {
      this.requestParams.page = 1;
    }
  }

  atualizarAtt(param, value) {
    if (value !== undefined && value !== null && value !== '') {
      if(this.attributes.length) {
        const pos = this.attributes.findIndex((object) => {
          return object.param === param;
        });

        if(pos === -1) {
          this.attributes.push({
            param: param,
            value: value,
          });
        } else {
          this.attributes[pos].value = value;
        }
      } else{
        this.attributes.push({
          param: param,
          value: value,
        });
      }
    } else {
      if (this.attributes.length > 0) {
        const pos = this.attributes.findIndex((object) => {
          return object.param === param;
        });
        this.attributes.splice(pos, 1);
      }
    }
  }

  verifydisabled(val): boolean {
    if (
      !val ||
      (val && typeof val !== 'number' && Object.values(val).length === 0)
    ) {
      return true;
    }
    return false;
  }

  verifyExistOption(valueoption: any): boolean {
    return (valueoption !== null && valueoption !== undefined && valueoption !== '');
  }

  ngOnInit() {
    const sleepTime = 300;
    this.formAux.valueChanges.pipe(
      takeUntil(this._onDestroy),
      debounceTime(sleepTime),
      distinctUntilChanged()
    ).subscribe((subs) => {
      this.loading = true;
      this.complete = false;
      if (!this.internalFilter) {
        if(this.labelShowSearch) {
          this.atualizarAtt(this.labelShowSearch, this.formAux.value);
        }
        if(this.labelShow) {
          this.atualizarAtt(this.labelShow, this.formAux.value);
        }
        if(this.labelShowPref) {
          this.atualizarAtt(this.labelShowPref, this.formAux.value);
        }
        if(this.labelShowSuf) {
          this.atualizarAtt(this.labelShowSuf, this.formAux.value);
        }

        this.requestParams.page = 1;
        this.requestParams.order = this.alphabeticalOrder ? 'asc' : '';
        this.requestParams.sort = this.alphabeticalShort ? this.alphabeticalShort : this.alphabeticalOrder ? this.labelShow : '';
        this.httpService.genericGetSelectFiltroScroll<[]>(this.configApi, this.endpoint, this.requestParams, this.attributes)
          .subscribe((option: any[] | any) => {
            if (this.hasCount) {
              this._options = option.rows;
            } else {
              this._options = option;
            }
            this.optionEmmiter.emit(this._options);
            this.inputSearchEmitter.emit(this.formAux.value);
            this.loading = false;
          });
      } else {
        if (!!this.formAux.value && this.labelShow) {
          this._options = this._oprtionOriginal
            ?.filter((option: string) => option[this.labelShow].toString().toLowerCase().includes(this.formAux.value.toLowerCase()));

        } else if (!!this.formAux.value) {
          this._options = this._oprtionOriginal
            .filter((option: string) => option.toString().toLowerCase().includes(this.formAux.value.toLowerCase()));

        } else {
          this._options = [...this._oprtionOriginal];
        }

        this.loading = false;
      }
    });
  }

  sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  i = 0;

  compare(arr1, arr2) {
    if (arr1 && arr2) {
      return (arr1.length === arr2.length) && arr1.every((element, index) => {
        return element === arr2[index];
      });
    }
    return false;
  }

  compareFn(itemFilter: any) {
    if (itemFilter['check']) {
      return itemFilter['check']
    }
  }

  returnLabel(op) {
    if (!this.isTableFilter) {
      if(this.labelShowPref && this.labelShow && this.labelShowSuf) {
        return `${op[this.labelShowPref]} ${op[this.labelShow]} ${op[this.labelShowPref]}`
      } else if(this.labelShowPref && this.labelShow) {
        return `${op[this.labelShowPref]} ${op[this.labelShow]}`
      } else if(this.labelShow && this.labelShowSuf) {
        return `${op[this.labelShow]} ${op[this.labelShowPref]}`
      } else if (this.labelShow && this.labelShowSufDate) {
        return `${op[this.labelShow]}${op[this.labelShowSufDate] ? ` - ${moment.parseZone(op[this.labelShowSufDate]).format('DD/MM/YYYY')}` : ''}`;
      } else if(this.labelShow) {
        return op[this.labelShow]
      }
    }
    return op;
  }

  verifyOptionsValueSelected(opts: any, value): string {
    const nowOption: any = opts?.findIndex((res: any) => res[this.returnVariable] === value);
    if (opts && nowOption !== -1) {
      const nowValue: any = opts[nowOption];
      return nowValue[this.labelShow];
    }
    return null;
  }

  returnValueSelect(value): string {
    let firstVal = this.verifyOptionsValueSelected(this._options, value);
    return firstVal;
  }

  updateOptions() {
    return this.httpService.genericGetSelectFiltroScroll<[]>(this.configApi,this.endpoint, this.requestParams, this.attributes)
      .toPromise().then((option: any[] | any) => {
        this.clearSelection()
        if (this.hasCount) {
          if (option?.rows) {
            this._options = option.rows;
            if(this.autoComplete && this.multiple && option?.count === 1) {
              setTimeout(() => {
                this._value = [option[0][this.returnVariable]]
                this.optionEmmiter.emit(this._options);
                this.inputSearchEmitter.emit(this.formAux.value);
                this.selectionChange.emit(this._value);
              }, 100)
              this._value = option.rows
            }
          } else {
            this._options = option;
          }
        } else {
          this._options = option;
          if(this.autoComplete && this.multiple && option?.length === 1) {
            setTimeout(() => {
            if(this.returnVariable) {
              this._value = [option[0][this.returnVariable]]
            } else {
              this._value = [option[0]]
            }
              // this._value = option

              this.optionEmmiter.emit(this._options);
              this.inputSearchEmitter.emit(this.formAux.value);
              this.selectionChange.emit(this._value);
            }, 100)
          }
        }
        this.optionEmmiter.emit(this._options);
        this.inputSearchEmitter.emit(this.formAux.value);

        if (!!this._options && this._options !== undefined && typeof this._value === "string") {
          if (!this?._options?.includes(this._value)) {
            this._value = null;
          }
        }
        if(!!this._options && this._value?.value) {
          const optionValue = this._options.find(option => option.value === this._value.value);
          if(!optionValue) {
            this._value = null
          } else {
            this._value = optionValue;
          };
        }
        if(this._value?.length > 0 && this.multiple && !this.autoComplete) {
          const newValue = this._options?.filter(option => {
            return this._value.includes(option);
          });
          this._value = newValue;
          if(newValue.lenght === 0) this._value = null;
        } else if(this.multiple && !this.autoComplete) {
          this._value = null;
        }
        // else if(this._value?.length > 0 && this.multiple && this.autoComplete) {
        //   setTimeout(() => {

        //     console.warn('this._options',this._options)
        //     const newValue = this._options?.filter(option => {
        //       console.warn('option',option)
        //       console.warn('this._value',this._value)
        //       return this._value.includes(option);
        //     });
        //     this._value = newValue.map((item)=> this.returnVariable ? item[this.returnVariable] : item);
        //   }, 2500)
        // }
        this.loading = false;
      }).catch();
  }
}
